import React from 'react'

import * as S from './styled'
import type { PageLayoutProps } from './types'

export const PageLayout = ({
  leftContent,
  rightContent,
  bottomContent,
  bottomContentMargin = 'large',
  size = 'medium',
  children,
  className,
}: PageLayoutProps) => (
  <S.Container $size={size} className={className}>
    {children}
    {(leftContent || rightContent) && (
      <S.InnerContainer>
        <S.LeftContent>{leftContent}</S.LeftContent>
        <S.RightContent data-testid="rightPanel">{rightContent}</S.RightContent>
      </S.InnerContainer>
    )}
    {bottomContent && (
      <S.BottomContent $margin={bottomContentMargin}>{bottomContent}</S.BottomContent>
    )}
  </S.Container>
)
